import { useDispatch, useSelector } from 'react-redux';
import React from 'react';
import { PromptButtonTypeEnum } from '@inter-ikea-kompis/component-prompt';
import { KompisPrompt, KompisText } from '@inter-ikea-kompis/react-components';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { actionCloseDialog } from '../../state/dialog/dialogActions';
import { translate } from '../../services/L10n';
import StopPropagation from '../utils/StopPropagation';
import { selectDialog } from '../../state/dialog/dialogSelectors';
import { thunkLoadPac } from '../../state/tac/tacThunks';
import { selectInitLoading } from '../../state/init/initSelectors';
import { t } from '../../translations';

const DeeplinkChoice = () => {
  const loading = useSelector(selectInitLoading);
  const dialog = useSelector(selectDialog);
  const dispatch = useDispatch();

  /**
   * Handle on return click
   */
  const returnClick = () => dispatch(actionCloseDialog());

  /**
   * Handle on continue click
   */
  const continueClick = () => {
    dispatch(thunkLoadPac(dialog.options.spr));
    dispatch(actionCloseDialog());
  };

  const isPrimaryButtonEvent = (type: PromptButtonTypeEnum) =>
    type === PromptButtonTypeEnum.primaryButton;

  const handleButtonClick = ({ detail: { type } }: any) =>
    isPrimaryButtonEvent(type) ? continueClick() : returnClick();

  return loading ? null : (
    <StopPropagation>
      <KompisPrompt
        visible={true}
        disableIframeSticky={true}
        theme={SkapaTheme}
        heading={translate(t.REPLACE_PREVIOUS_HEADING)}
        primaryButtonLabel={translate(t.REPLACE_PREVIOUS_PRIMARY)}
        secondaryButtonLabel={translate(t.REPLACE_PREVIOUS_SECONDARY)}
        onButtonClick={handleButtonClick}
      >
        <KompisText theme={SkapaTheme}>
          {translate(t.REPLACE_PREVIOUS_BODY)}
        </KompisText>
      </KompisPrompt>
    </StopPropagation>
  );
};

export default DeeplinkChoice;
